import React from "react";
import styled from "styled-components";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import {faDatabase} from "@fortawesome/free-solid-svg-icons";
import {faWordpress, faHtml5, faCss3, faReact, faLaravel, faPhp, faJs, faSymfony} from '@fortawesome/free-brands-svg-icons'


import Services from './services';

const Carrousel = (props) => {
   return(
      <Contenedor >
         <h2 className="title" id="skills">My Skills</h2>
         <OwlCarousel
            className="owl-theme"
            margin={10}
            nav
            autoWidth
            loop
            autoplay={true}
            autoplayTimeout={1500}
            autoplayHoverPause={true}
            center
            >
               <Services icon={faHtml5} name="HTML" description="" />
               <Services icon={faCss3} name="CSS" description="" />
               <Services icon={faJs} name="Javascript" description="" />
               <Services icon={faReact} name="React" description="" />
               <Services icon={faPhp} name="PHP" description="" />
               <Services icon={faLaravel} name="Laravel" description="" />
               <Services icon={faSymfony} name="Symfony" description="" />
               <Services icon={faDatabase} name="Databases" description="" />
               <Services icon={faWordpress} name="Wordpress" description="" />
         </OwlCarousel>
      </Contenedor>
   );
}
export default Carrousel;
 const Contenedor = styled.div`
   margin: 0 auto 4rem auto;
   .title{
      text-align: center;
      color: white;
      text-transform: uppercase;
      font-size: 1.7rem;
   }
 `;